<script>
export default {
    name: "ReturnInfoModal",

    props: {

        showModal: Boolean,
        investigation: Object,
        other: {
            type: Boolean,
            default: false
        },
        returnInfo: Array,
    },
}
</script>
<template>
<tail-modal :show="showModal" dimension="md:w-1/2 w-10/12">
  <template v-slot:title>
    <h5 class="font-medium text-lg">Return Details</h5>
  </template>
  <template v-slot:modal-body>
    <div class="w-full flex flex-wrap items-center">
        <div class="md:w-1/2 w-full p-3">
            Request ID: {{ investigation.patientLabResultId || investigation.invoiceDetailID }}
             <h5 class="font-medium text-sm capitalize">
                Test: {{investigation.test || investigation.service}}</h5>
        </div>
        <div class="md:w-1/2 w-full p-3">
            <h5 class="font-medium text-sm capitalize">
                Patient: {{investigation.patient || investigation.names}}</h5>
        </div>
        <div class="md:w-1/2 w-full p-3">
            <h5 class="font-medium text-sm capitalize">
              MRN: {{investigation.patientId || investigation.patientID}}</h5>
        </div>
        <div class="md:w-1/2 w-full p-3">
            <h5 class="font-medium text-sm capitalize">
                OP File No: {{investigation.opfileno}}</h5>
        </div>
        <div class="md:w-1/2 w-full p-3">
            <h5 class="font-medium text-sm capitalize">
                IP File No: {{investigation.ipfileno}}</h5>
        </div>
        <div class="md:w-1/2 w-full p-3">
            <h5 class="font-medium text-sm capitalize">
                Status: {{investigation.patientstatus}}</h5>
        </div>
        <div class="md:w-1/2 w-full p-3">
            <h5 class="font-medium text-sm capitalize">
                Payment Mode: {{investigation.paymentMode || `-`}}</h5>
        </div>
        <div class="md:w-1/2 w-full p-3">
            <h5 class="font-medium text-sm capitalize">
                Visit Payment Mode: {{investigation.pMode || investigation.pmode}}</h5>
        </div>
        <div class="md:w-1/2 w-full p-3">
            <h5 class="font-medium text-sm capitalize">Age: {{investigation.age}}</h5>
        </div>
        <div class="md:w-1/2 w-full p-3" v-if="other">
            <h5 class="font-medium text-sm">Date: {{investigation.txnDate | dateFormat}}</h5>
        </div>
        <div class="md:w-1/2 w-full p-3" v-if="!other">
            <h5 class="font-medium text-sm">Request Date: {{investigation.date | dateFormat}}</h5>
        </div>
        <div class="md:w-1/2 w-full p-3" v-if="!other">
            <h5 class="font-medium text-sm">Done Date: {{investigation.doneDate | dateFormat}}</h5>
        </div>
        <div class="w-full p-2 my-2 bg-gray-300">
            <h5 class="font-medium text-sm">Return Information</h5>
        </div>
        <div class="w-full p-2 border-t my-2" 
            v-for="rInfo in returnInfo" :key="rInfo.auditId">
            <div class="w-full p-2">
                <h5 class="font-medium text-xs capitalize my-1">
                    Date: {{ rInfo.sysDate | dateFormat }}</h5>
                <p class="text-xs mt-1" v-html="rInfo.memo"></p>
            </div>
            <div class="w-full flex flex-wrap mt-1 p-2">
                <div class="flex-1">
                    <h5 class="font-medium text-xs capitalize my-1">
                        Returned By: {{ rInfo.userName }}</h5>
                </div>
            </div>
        </div>
    </div>
  </template>
  <template v-slot:modal-footer>
    <button class="btn-danger btn-sm text-xs rounded" @click.prevent="$emit(`closeModal`)">
        <i class="fa fa-times"></i> Close</button>
  </template>
</tail-modal>
</template>